import { define, c } from '@components/Component.js'
import { h } from '@core/dom.js'
import { signal, effect } from '@core/signal.js'
import { directoryData } from '@/db/directory.db.js'

const isActive = b => {
    if (b.enabled === false) return false
    const now = new Date()
    if (b.activeFrom && new Date(b.activeFrom) > now) return false
    if (b.activeTo   && new Date(b.activeTo)   < now) return false
    return true
}

define('CategoryStrip', () => {
    const categoriesSignal = signal(
        directoryData.categories.map(cat => ({ ...cat, count: 0 }))
    )

    fetch(`/data/businesses.json?t=${Date.now()}`)
        .then(r => r.json())
        .then(data => {
            const items = (data.items || []).filter(isActive)
            categoriesSignal.set(
                directoryData.categories.map(cat => ({
                    ...cat,
                    count: items.filter(b => b.categorySlug === cat.slug).length
                }))
            )
        })
        .catch(() => {})

    const strip = h('div', { className: 'cat-strip__scroll' })

    let dragging = false, startX = 0, scrollLeft = 0
    strip.addEventListener('mousedown', e => {
        dragging = true
        startX = e.clientX
        scrollLeft = strip.scrollLeft
        strip.style.scrollBehavior = 'auto'
        strip.style.cursor = 'grabbing'
    })
    strip.addEventListener('mousemove', e => {
        if (!dragging) return
        e.preventDefault()
        strip.scrollLeft = scrollLeft - (e.clientX - startX)
    })
    strip.addEventListener('mouseup', () => { dragging = false; strip.style.cursor = ''; strip.style.scrollBehavior = '' })
    strip.addEventListener('mouseleave', () => { dragging = false; strip.style.cursor = ''; strip.style.scrollBehavior = '' })

    effect(() => {
        const list = categoriesSignal.get().filter(cat => cat.count > 0)
        while (strip.firstChild) strip.removeChild(strip.firstChild)
        list.forEach(cat => {
            strip.appendChild(
                h('a', { className: 'cat-strip__item', href: `/directorio/${cat.slug}` },
                    h('span', { className: 'cat-strip__icon' }, cat.icon),
                    h('span', { className: 'cat-strip__name' }, cat.name),
                    h('span', { className: 'cat-strip__count' }, `${cat.count}`)
                )
            )
        })
    })

    return h('section', { className: 'cat-strip' },
        h('div', { className: 'cat-strip__inner' },
            h('div', { className: 'cat-strip__header' },
                h('h2', { className: 'cat-strip__title' }, 'Explora por categoria'),
                h('a',  { className: 'cat-strip__see-all', href: '/directorio' }, 'Ver todas →')
            ),
            strip
        )
    )
})
